import { styled } from '@f8n-frontend/stitches';

import Heading from 'components/base/Heading';

const CollectionTitle = styled(Heading, {
  lineHeight: '$0',
  color: '$white100',
  wordBreak: 'break-word',
  maxWidth: 720,
  '@bp2': {
    fontSize: '$9',
  },
  variants: {
    color: {
      dark: {
        color: '$black100',
      },
      light: {
        color: '$white100',
      },
    },
  },
});

export default CollectionTitle;
